module.exports = __webpack_public_path__ + "img/gauge-simple-med.e5fe0214.svg";